const LeisureTravel = () => {
    return (
        <div>
        <div className="flex flex-col justify-center items-center">
        <hr className="w-full lg:w-[50rem] md:w-[46rem]  mx-[auto] md:mx-[auto]"/>
        <div className="lg:flex md:flex sm:flex grid flex-1 justify-center items-start mx-auto lg:max-w-[50rem] md:max-w-[46rem] sm:max-w-[43rem] my-[5rem] gap-14">

                <div className="px-1 flex flex-col justify-center">
                    <h1 className="font-bold lg:text-3xl text-2xl text-[#373737]">
                        Leisure Travel
                    </h1>
                    <p className="text-sm text-md  lg:max-w-[25rem] md:w-[24rem] sm:w-[19rem] mt-[1rem]">
                        Whether you are looking for cruises to exotic destinations, an individual adventure holiday 
                        or a group excursion, TCS Travel & Tours provides a wide variety of international and domestic 
                        travel and tours related services, on all major domestic and international carriers. To meet customers’ 
                        travel related needs, TCS Travel & Tours offers exclusive, as well as customised packages to suit 
                        their budgets.
                    </p>
                    
                </div>
                <div className="flex-1 flex flex-col justify-center items-center sm:mt-[0rem] mt-[1rem]">
                    <img src="/Intiana/leisure.jpg" alt="" className="rounded-md max-w-[100%]"/>
                    
                </div>
            </div>

        </div>

    </div>
    )
}
export default LeisureTravel;